document.addEventListener('DOMContentLoaded', function() {
  // Header dark/light on hero
  var header = document.querySelector('.site-header');
  var hero = document.querySelector('.hero');
  if (header && hero) {
    header.classList.add('site-header--dark');
    new IntersectionObserver(function(entries) {
      header.classList.toggle('site-header--dark', entries[0].isIntersecting);
    }, { threshold: 0.05 }).observe(hero);
  }

  // Cart count refresh
  function refreshCart() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
      document.querySelectorAll('.site-header__cart-btn').forEach(function(el) {
        el.textContent = c.item_count > 0 ? 'Cart (' + c.item_count + ')' : 'Cart';
      });
    });
  }
  refreshCart();

  // Add to cart
  document.querySelectorAll('.js-add-to-cart').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var form = this.closest('form');
      var id = form ? form.querySelector('[name="id"]').value : this.dataset.variantId;
      if (!id) return;
      var orig = this.textContent;
      this.textContent = 'Adding...'; this.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      }).then(function() {
        refreshCart();
        btn.textContent = 'Added';
        setTimeout(function() { btn.textContent = orig; btn.disabled = false; }, 1800);
      }).catch(function() { btn.textContent = orig; btn.disabled = false; });
    });
  });

  // PDP thumbnail switcher
  var thumbs = document.querySelectorAll('.pdp__thumb');
  var mainImg = document.getElementById('pdp-main-img');
  if (mainImg) {
    thumbs.forEach(function(btn) {
      btn.addEventListener('click', function() {
        thumbs.forEach(function(b) { b.classList.remove('pdp__thumb--active'); });
        this.classList.add('pdp__thumb--active');
        mainImg.style.opacity = '0.5';
        mainImg.src = this.dataset.src;
        mainImg.onload = function() { mainImg.style.opacity = '1'; };
      });
    });
  }

  // Newsletter
  document.querySelectorAll('.js-newsletter-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = this.querySelector('button[type="submit"]');
      btn.textContent = 'Thank you'; btn.disabled = true;
    });
  });

  // Scroll reveal
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(en) {
        if (en.isIntersecting) {
          en.target.style.opacity = '1';
          en.target.style.transform = 'translateY(0)';
          obs.unobserve(en.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.statement,.brand-promise,.journal-section,.discovery-band,.collection-header').forEach(function(el) {
      el.style.cssText += 'opacity:0;transform:translateY(18px);transition:opacity 0.7s ease,transform 0.7s ease;';
      obs.observe(el);
    });
  }
});
